// el-form validation rule helper
import lodash from 'lodash'
import ErrorBag from '@/assets/scripts/errorbag'
import regexes from '@/config/regexes'

// dictionary for fields
const Dictionary = {
  'zh-cn': {
    emailOrCellphone: '邮箱/手机号',
    email: '邮箱',
    password: '密码',
    oldPassword: '原始密码',
    newPassword: '新的密码',
    passwordConfirmation: '确认密码',
    cellphone: '手机号',
    captcha: '短信验证码',
    realname: '真实姓名',
    province: '省份',
    organization: '任教学校',
    certificate: '证件图片',
    cannotBeEmpty: '不能为空',
    notValidFormat: '不是有效的格式',
    and: '与',
    notMatch: '不匹配'
  }
}

const locale = process.env.LOCALE

let $t = word => {
  return Dictionary[locale][word]
}

const rules = {
  required: function(attributes) {
    let vm = this
    attributes = lodash.isArray(attributes) ? attributes : [attributes]

    let requiredValidator = (rule, value, callback) => {
      if (!value) {
        let errorMessage = $t(rule.field) + $t('cannotBeEmpty')
        vm.errors.add(rule.field, errorMessage)
        callback(new Error(errorMessage))
      } else {
        callback()
      }
    }

    return attributes.reduce((result, attribute) => {
      result[attribute] = [{
        validator: requiredValidator,
        trigger: 'blur'
      }]
      return result
    }, {})
  },
  confirmed: function(attributes) {
    let vm = this
    attributes = lodash.isArray(attributes) ? attributes : [attributes]

    function confirmedValidator(rule, value, callback) {
      let recursion = this.recursion
      let original = this.original
      let target = this.target
      // use vm and recusive to get compaired data
      let searching = (result, recursion = '') => {
        let current = recursion.split('.')[0]

        if (current) {
          result = result[current]
        }

        let next = recursion.substr(current.length + 1)
        if (!next) {
          return result
        } else {
          return searching(result, next)
        }
      }

      let compared = searching(vm.$data, recursion)[original]
      if (value !== compared) {
        let errorMessage = $t(target) + $t('and') + $t(original) + $t('notMatch')
        vm.errors.add(rule.field, errorMessage)
        callback(new Error(errorMessage))
      } else {
        callback()
      }
    }

    return attributes.reduce((result, attribute) => {
      result[attribute.target] = [{
        validator: function() {
          confirmedValidator.apply(attribute, arguments)
        },
        trigger: 'blur'
      }]
      return result
    }, {})
  },
  email: function(attributes) {
    let vm = this
    attributes = lodash.isArray(attributes) ? attributes : [attributes]

    let emailValidator = (rule, value, callback) => {
      if (!regexes.email.test(value)) {
        let errorMessage = $t(rule.field) + $t('notValidFormat')
        vm.errors.add(rule.field, errorMessage)
        callback(new Error(errorMessage))
      } else {
        callback()
      }
    }

    return attributes.reduce((result, attribute) => {
      result[attribute] = [{
        validator: emailValidator,
        trigger: 'blur'
      }]
      return result
    }, {})
  }
}

export default {
  props: {
    // 记录表单上各个元素，在前端验证上是否有错误的集合
    errors: {
      default: () => {
        return new ErrorBag()
      }
    },
    rules: {
      // rules 会被 el-form使用，作为el-form需要的rules， 见 http://element.eleme.io/1.4/#/zh-CN/component/form
      default: function() {
        let vm = this
        if (!vm.$options.rules) return null

        // 对 rules 所有有效的[const rules 定义了的]规则，生成对应的validator
        let validators = lodash.keys(vm.$options.rules).filter(key => lodash.isFunction(rules[key])).map(key => {
          // key is someting like 'required', 'confirmed'
          return rules[key].call(vm, vm.$options.rules[key])
        })

        return lodash.assignWith({}, ...validators, function(d, s) {
          return d ? lodash.concat(d, s) : s
        })
      }
    }
  },
  methods: {
    clearErrors(field) {
      field ? this.errors.remove(field) : this.errors.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validator.js